module.exports = __webpack_public_path__ + "static/img/9.cc6f80b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/9.png
// module id = WIjo
// module chunks = 0